import { EXT_ENDPOINT } from 'consts/api';
import { LS } from 'consts/localStorage';
import { debug, initXMLhttp, writeToLs } from 'helpers/helpers';
import { ENGT_CHAT } from 'js/bot.model';

export function uploadFile() {
	const ref = this;
	const http = initXMLhttp();
	const payload = new FormData();
	const { public_upload, transaction_id } = this.data?.message || {};
	const file = this.data.uploadedFile;
	if (!file) {
		return;
	}

	this.uploadRequest = http;
	payload.append('file', file);
	payload.append('workflow', public_upload == true ? 'PUBLIC_ATTACHMENT' : 'ENGATI_ATTACHMENT');
	payload.append('application', 'engati-bot');

	try {
		http.open('POST', EXT_ENDPOINT().ATTACHMENTS, true);
		http.setRequestHeader('transactionId', transaction_id || '');
		http.setRequestHeader('timeStamp', new Date().getTime());
		http.setRequestHeader(
			'customInfo',
			JSON.stringify({
				user_id: ENGT_CHAT.get('status.sessionKey'),
				bot_ref: parseInt(ENGT_CHAT.get('config.botRef')),
			})
		);
		http.upload.addEventListener('progress', (event) => {
			if (event.lengthComputable) {
				ref.showProgressBar((event.loaded / event.total) * 100);
			}
		});
		http.onreadystatechange = function () {
			let respJson;
			try {
				respJson = JSON.parse(http.responseText);
			} catch (e) {
				respJson = http.responseText;
			}

			if (this.readyState === 4 && this.status === 200) {
				if (respJson?.status?.code === 1000) {
					ref.resetProgressBar();
					ref.destroyNode(ref.uploadBtn, ref.skipButton);
					writeToLs(
						LS().TAB_MESSAGES,
						JSON.stringify({
							tabId: ENGT_CHAT.get('socketId'),
							action: 'update_file_msg',
							fileName: file.name,
							fileLink: file.type.indexOf('image') > -1 ? URL.createObjectURL(file) : file.url,
							fileType: file.type,
							fileSize: file.size,
							id: ref.data.id,
						})
					);
					ref.sendFileViaSocket(respJson, public_upload == true);
					ENGT_CHAT.get('enableAllInput')();
				} else if (respJson?.status?.code === 28009) {
					debug(`Invalid file extenstion error -> ${respJson} >> data >> ${ref.data}`);
					ref.setError('File not supported !');
					ref.resetProgressBar();
				} else if (respJson?.status?.code === 28014) {
					debug(`File upload error -> ${respJson} >> data >> ${ref.data}`);
					ref.setError('Error !!!');
					ref.resetProgressBar();
				} else if (respJson?.status?.code === 28010) {
					debug(`Invalid File Size error -> ${respJson} >> data >> ${ref.data}`);
					ref.setError('Invalid File Size, size limit is 5MB!');
					ref.resetProgressBar();
				} else {
					if (respJson?.status?.desc) {
						debug(`File Error -> ${respJson?.status?.desc}`);
					}
					ref.resetProgressBar();
				}
			}
		};
		http.send(payload);
	} catch (error) {
		debug(`File upload error -> ${error} >> data >> ${ref.data}`);
		ref.setError('Error !!!');
	}
}
